/**
 * View state for the player card analysis card (tab + selected recommendation
 * list date per profile). Lives in redux instead of component state because the
 * PDF exporter needs the same selection from outside the recommendations tab.
 * Not persisted — SPA-session lifetime.
 */

import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import type { RootState } from "../store"

export type AnalysisTab = "profile" | "recommendations" | "overview" | "documents"

interface PlayerCardAnalysisState {
	activeTabByProfile: Record<string, AnalysisTab>
	// undefined = never chosen (default to today's list if it exists); null = explicit "new/empty template"
	selectedDateByProfile: Record<string, string | null>
}

const initialState: PlayerCardAnalysisState = {
	activeTabByProfile: {},
	selectedDateByProfile: {},
}

export const playerCardAnalysisSlice = createSlice({
	name: "playerCardAnalysis",
	initialState,
	reducers: {
		setAnalysisTab(state, { payload }: PayloadAction<{ profileId: string; tab: AnalysisTab }>) {
			state.activeTabByProfile[payload.profileId] = payload.tab
		},
		setRecommendationDate(state, { payload }: PayloadAction<{ profileId: string; date: string | null }>) {
			state.selectedDateByProfile[payload.profileId] = payload.date
		},
	},
})

export const { setAnalysisTab, setRecommendationDate } = playerCardAnalysisSlice.actions
export const selectAnalysisTab = (state: RootState, profileId: string): AnalysisTab =>
	state.playerCardAnalysis.activeTabByProfile[profileId] ?? "profile"

/** undefined = no explicit pick this session; null = explicit "new/empty template". */
export const selectRecommendationDate = (state: RootState, profileId: string): string | null | undefined =>
	profileId in state.playerCardAnalysis.selectedDateByProfile ? state.playerCardAnalysis.selectedDateByProfile[profileId] : undefined
